import { ApiError, panelErrorTitle } from "@/lib/api-client";

interface PanelLoadingProps {
  height?: number;
}

export function PanelLoading({ height = 160 }: PanelLoadingProps) {
  return (
    <div
      className="flex items-center justify-center rounded-lg bg-surface-card/40"
      style={{ height }}
    >
      <div className="h-3 w-32 animate-pulse rounded bg-surface-skeleton" />
    </div>
  );
}

interface PanelErrorProps {
  error: unknown;
  onRetry?: () => void;
}

export function PanelError({ error, onRetry }: PanelErrorProps) {
  const title = panelErrorTitle(error);
  const requestId = error instanceof ApiError ? error.requestId : undefined;
  return (
    <div className="flex flex-col items-center justify-center gap-2 rounded-lg border border-dashed border-danger/30 bg-danger/5 px-3 py-8 text-center">
      <div className="text-sm text-danger-text">{title}</div>
      {requestId && (
        <div className="font-mono text-[10px] text-fg-disabled">
          requestId: {requestId}
        </div>
      )}
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="mt-1 rounded border border-border-subtle px-3 py-1 text-xs text-neutral-text transition-colors hover:bg-surface-raised/60"
        >
          Try again
        </button>
      )}
    </div>
  );
}
